import { RefObject } from "react";

export const setInputFocus = (ref: RefObject<HTMLElement>) => {
  if (ref) {
    ref.current?.focus();
  }
};
